import colormap from 'colormap';
import config from "../config.json"

const ndviColormap = colormap({
    colormap:
        [
            { index: 0, rgb: config.colormaps["NDVI"].values.index_0 },
            { index: 0.5, rgb: config.colormaps["NDVI"].values.index_0_5 },
            { index: 1, rgb: config.colormaps["NDVI"].values.index_1 }
        ],
    nshades: 50
})

const ndwiColormap = colormap({
    colormap:
        [
            { index: 0, rgb: config.colormaps["NDWI"].values.index_0 },
            { index: 0.5, rgb: config.colormaps["NDWI"].values.index_0_5 },
            { index: 1, rgb: config.colormaps["NDWI"].values.index_1 }
        ],
    nshades: 50
})

export function getColor(value, type) {
    // minus one to reverse colorramp
    const steps = 50
    if (type === "NDVI") {
        var min = config.colormaps[type].min
        var max = config.colormaps[type].max
        const f = clamp((value - min) / (max - min), 0, 1)
        const i = Math.round(f * (steps - 1))
        return ndviColormap[i]
    }
    else if (type === "NDWI") {
        var min = config.colormaps[type].min
        var max = config.colormaps[type].max
        const f = clamp((value - min) / (max - min), 0, 1)
        const i = Math.round(f * (steps - 1))
        return ndwiColormap[i]
    }
    else return

}






function clamp(value, low, high) {
    return Math.max(low, Math.min(value, high))
}
